import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-delete-customer-card',
  templateUrl: './delete-customer-card.component.html',
  styleUrl: './delete-customer-card.component.scss',
  standalone: false
})
export class DeleteCustomerCardComponent {

  cardDetails: any;
  processing: any;
  ErrorMessage?: string;
  check_subscription_plans: any;
  showCardDetachingLoader = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public method: any,

    private dialogRef: MatDialogRef<DeleteCustomerCardComponent>,
    public userServices: UserService
  ) {
    this.cardDetails = data.value || [method];
    this.check_subscription_plans = data.subscription_plans;
  }
  ngOnInit(): void { }

  deleteCard() {
    this.processing = true;
    try {
      const { payment_method_id, user_UUID } = this.cardDetails;

      if (!payment_method_id || !user_UUID) {
        this.processing = false;
        this.ErrorMessage = 'Invalid card details.';
        return;
      }

      this.userServices.deletePaymentMethod(payment_method_id, user_UUID).subscribe({
        next: (res) => {

          if (res.success) {
            setTimeout(() => {
              this.processing = false;
              this.dialogRef.close(true);
            }, 3000)
          }

          else {
            this.processing = false
            if (res.message) {
              this.ErrorMessage = res.message
            }
            else {
              this.ErrorMessage = "Unable to detach the card, please try later"
            }
          }

        },
        error: (error) => {
          this.processing = false;

          if (error?.error?.message) {
            this.ErrorMessage = error.error.message;
          } else {
            this.ErrorMessage = 'Something went wrong. Please try again later.';
          }
        }
      });

    } catch (error) {
      this.processing = false;
      this.ErrorMessage = 'Unexpected error occurred. Please try again.';
      console.error('Unexpected error:', error);
    }
  }

  close() {
    this.dialogRef.close('cancelDialog');
  }

  getCardIcon(brand: string) {
    const map: any = {
      visa: 'https://cdn-icons-png.flaticon.com/512/196/196578.png',
      mastercard: 'https://cdn-icons-png.flaticon.com/512/196/196561.png',
      amex: 'https://cdn-icons-png.flaticon.com/512/349/349221.png',
      discover: 'https://cdn-icons-png.flaticon.com/512/349/349230.png',
      jcb: 'https://cdn-icons-png.flaticon.com/512/349/349228.png',
      diners: 'https://cdn-icons-png.flaticon.com/512/349/349222.png'
    };

    return map[brand] || 'https://cdn-icons-png.flaticon.com/512/565/565547.png'; // fallback icon
  }
}
